import React from 'react';
import { Description, IconWrapper, Title, Wrapper } from './verification-error.styles';
import { Button } from '@vtbhome/juicyfront';
import { ROUTE_AUTH } from '@shared/config/routes/routes';
import { IconError } from '@shared/icon/icon-error/icon-error';
import { VerificationErrorProps } from './types';
import { useRedirect } from '@shared/lib/hooks/use-redirect/use-redirect';

export const VerificationError: React.FC<VerificationErrorProps> = ({ error }) => {
    const redirect = useRedirect();

    const handleGoLogin = () => {
        redirect({ url: ROUTE_AUTH });
    };

    return (
        <Wrapper>
            <IconWrapper>
                <IconError />
            </IconWrapper>
            <Title size='h4'>Возникла ошибка</Title>
            <Description size='subtitle1'>{error}</Description>
            <Button fullWidth onClick={handleGoLogin}>
                Вернуться к форме входа
            </Button>
        </Wrapper>
    );
};
